module.exports = __webpack_public_path__ + "img/a8.1c76f054.svg";